export default "/images/vendor/@coreui/icons/svg/flag/cif-do.svg?104b6bb9ebb337b5eee0d775152dcf85";